(function () {
  'use strict';

  angular.module('app').component('costsAndPricesDetail', CostsAndPricesComponent());

  function CostsAndPricesComponent() {
    return {
      bindings: {
        defaultLanguage: '<',
      },
      controller: CostsAndPricesCtrl,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/costs-and-prices/costs-and-prices-detail/costs-and-prices-detail.component.html',
    };
  }

  CostsAndPricesCtrl.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'TourService',
    'TransportationService',
    'HotelService',
    'PackageService',
    '$timeout',

    // Angular downgraded service
    'zoneService',
    'seasonService',
    'seasonModalService',
  ];

  function CostsAndPricesCtrl(
    config,
    UtilService,
    TourService,
    TransportationService,
    HotelService,
    PackageService,
    $timeout,

    // Angular downgraded service
    zoneService,
    seasonService,
    seasonModalService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.dateDisplay = config.DATE_DISPLAY_SHORT;
    vm.search = {};

    // public methods
    // -----------------------
    vm.selectSeason = function (season) {
      if (vm.seasonSelected && vm.seasonSelected.id === season.id) return;

      vm.seasonSelected = season;
    };

    vm.selectProductType = function (productType) {
      if (vm.productTypeSelected === productType) return;

      vm.productTypeSelected = productType;
      vm.search.product_type = productType;

      vm.search.product_id = null; // !important
      vm.productSelected = null;

      getProductsByProducType();
    };

    vm.selectProduct = function (product) {
      if (vm.productSelected && vm.productSelected.id === product.id) return;

      vm.productSelected = product;

      // Required to clear previus product selected memory
      if (vm.productTypeSelected === 'tour' || vm.productTypeSelected === 'transportation') {
        vm.zonesLoaded = false;
        getZonesByProduct(vm.productSelected, vm.productTypeSelected);
      } else {
        vm.zonesLoaded = true;
      }
    };

    vm.goToOtherProduct = function (otherProductId) {
      vm.loadingOtherProduct = true;
      $timeout(function () {
        // To avoid multiple clicks on navigation buttons
        let product = vm.products.find((product) => product.id === otherProductId);

        vm.search.product_id = product.id;

        vm.selectProduct(product);

        vm.loadingOtherProduct = false;
      }, 500);
    };

    vm.openSeasonsModal = function () {
      let successCallback = function () {
        getSeasons();
      };

      seasonModalService.openSeasonsModal(successCallback);
    };

    vm.onProductCostsAndPricesSaved = function () {
      // console.log('onProductCostsAndPricesSaved');
    };

    vm.$onInit = function () {
      // vm.zonesLoaded    = true; // important
      vm.zonesByProduct = [];

      vm.showCosts = true;
      vm.showPrices = true;

      // Initilizers
      getSeasons();

      let productTypes = angular.copy(vm.UtilService.getProductTypes());
      vm.productTypes = vm.UtilService.removeItemFromArray(productTypes, 'type', 'service_item');

      vm.selectProductType('tour');
    };

    // private methods
    // -----------------------

    // Get active seasons
    function getSeasons() {
      // current, where to is equal or less than today, check utc
      let params = {
        get: 'current',
        lang: vm.defaultLanguage,
        skip_check_role: true,
      };

      vm.loadingSeasons = true;
      seasonService.getSeasons(params).subscribe((response) => {
        vm.seasons = response.filter((season) => season.name); // In case of empty translation

        if (vm.seasons.length > 0) {
          let currentSeason = vm.seasons[0];

          vm.search.season_id = currentSeason.id;

          vm.selectSeason(currentSeason);
        }

        vm.loadingSeasons = false;
      });
    }

    function getProductsByProducType() {
      switch (vm.productTypeSelected) {
        case 'tour':
          vm.labelSelectProduct = 'SELECT_TOUR';
          vm.labelNotAvailableProducts = 'NOT_AVAILABLE_TOURS';

          vm.addProductRoute = 'tour_new';

          vm.applyPickupCostsAndPrices = true;

          getTours();
          break;
        case 'transportation':
          vm.labelSelectProduct = 'SELECT_TRANSPORTATION';
          vm.labelNotAvailableProducts = 'NOT_AVAILABLE_TRANSPORTATION';

          vm.addProductRoute = 'transportation_new';

          vm.applyPickupCostsAndPrices = true;

          getTransportations();
          break;
        case 'hotel':
          vm.labelSelectProduct = 'SELECT_HOTEL';
          vm.labelNotAvailableProducts = 'NOT_AVAILABLE_HOTELS';

          vm.addProductRoute = 'hotel_new';

          vm.applyPickupCostsAndPrices = false;

          getHotels();
          break;
        case 'package':
          vm.labelSelectProduct = 'SELECT_PACKAGE';
          vm.labelNotAvailableProducts = 'NOT_AVAILABLE_PACKAGES';

          vm.addProductRoute = 'package_new';

          vm.applyPickupCostsAndPrices = false;

          getPackages();
          break;
      }
    }

    function getTours() {
      vm.loadingProducts = true;

      if (vm.tours) {
        $timeout(function () {
          // Hack
          vm.products = vm.tours;

          vm.loadingProducts = false;
        }, 50);

        return;
      }

      let params = {
        get: 'active',
        search: true,
        providers: true,
        skip_check_role: true,
      };

      TourService.getTours(params).then(function (data) {
        vm.tours = [];

        data.items.forEach(function (item, index) {
          let product = {
            id: item.id,
            name: item.name,
            code: item.code,
            location_id: item.location_id,
            tour_options: item.tour_options,
            associated_providers: item.associated_providers,
            default_provider_id: item.default_provider_id,
            company_id: item.company_id,
            prev: data.items[index - 1],
            next: data.items[index + 1],
          };

          vm.tours.push(product);
        });

        vm.products = vm.tours;
        vm.loadingProducts = false;
      });
    }

    function getTransportations() {
      vm.loadingProducts = true;

      if (vm.transportations) {
        $timeout(function () {
          // Hack
          vm.products = vm.transportations;

          vm.loadingProducts = false;
        }, 50);

        return;
      }

      let params = {
        get: 'active',
        search: true,
        providers: true,
        skip_check_role: true,
      };

      TransportationService.getTransportations(params).then(function (data) {
        vm.transportations = [];

        data.items.forEach(function (item, index) {
          let product = {
            id: item.id,
            name: item.name,
            code: item.code,
            departure_location_id: item.departure_location_id,
            arrival_location_id: item.arrival_location_id,
            schedule_type: item.schedule_type,
            transportation_schedules: item.transportation_schedules,
            associated_providers: item.associated_providers,
            default_provider_id: item.default_provider_id,
            company_id: item.company_id,
            prev: data.items[index - 1],
            next: data.items[index + 1],
          };

          vm.transportations.push(product);
        });

        vm.products = vm.transportations;
        vm.loadingProducts = false;
      });
    }

    function getHotels() {
      vm.loadingProducts = true;

      if (vm.hotels) {
        $timeout(function () {
          // Hack
          vm.products = vm.hotels;

          vm.loadingProducts = false;
        }, 50);

        return;
      }

      let params = {
        get: 'active',
        search: true,
        providers: true,
        skip_check_role: true,
      };

      HotelService.getHotels(params).then(function (data) {
        vm.hotels = [];

        data.items.forEach(function (item, index) {
          let product = {
            id: item.id,
            name: item.name,
            code: item.code,
            location_id: item.location_id,
            hotel_rooms: item.hotel_rooms,
            associated_providers: item.associated_providers,
            default_provider_id: item.default_provider_id,
            company_id: item.company_id,
            prev: data.items[index - 1],
            next: data.items[index + 1],
          };

          vm.hotels.push(product);
        });

        vm.products = vm.hotels;
        vm.loadingProducts = false;
      });
    }

    function getPackages() {
      vm.loadingProducts = true;

      if (vm.packages) {
        $timeout(function () {
          // Hack
          vm.products = vm.packages;

          vm.loadingProducts = false;
        }, 50);

        return;
      }

      let params = {
        get: 'active',
        search: true,
        providers: true,
        skip_check_role: true,
      };

      PackageService.getPackages(params).then(function (data) {
        vm.packages = [];

        data.items.forEach(function (item, index) {
          let product = {
            id: item.id,
            name: item.name,
            code: item.code,
            departure_location_id: item.departure_location_id,
            arrival_location_id: item.arrival_location_id,
            // package_days:          item.package_days,
            associated_providers: item.associated_providers,
            default_provider_id: item.default_provider_id,
            company_id: item.company_id,
            prev: data.items[index - 1],
            next: data.items[index + 1],
          };

          vm.packages.push(product);
        });

        vm.products = vm.packages;
        vm.loadingProducts = false;
      });
    }

    // Get active zones by product location
    function getZonesByProduct(product, productType) {
      if (!product.location_id && !product.departure_location_id) {
        vm.zonesByProduct = [];
        return;
      }

      if (vm.zonesByProduct[product.id]) return;

      let filterCriteria;

      switch (
        productType // Required to clear previus product selected memory
      ) {
        case 'tour':
          filterCriteria = {
            get: 'by_location',
            location_id: product.location_id,
          };
          break;
        case 'transportation':
          filterCriteria = {
            get: 'by_locations',
            'location_ids[]': [product.departure_location_id, product.arrival_location_id],
          };
          break;
      }

      filterCriteria.lang = vm.defaultLanguage;
      filterCriteria.skip_check_role = true;

      zoneService.getZones(filterCriteria).subscribe((response) => {
        vm.zonesByProduct[product.id] = [];

        response.items.forEach(function (item) {
          let zone = {
            id: item.id,
            name: item.name,
          };

          vm.zonesByProduct[product.id].push(zone);
        });

        vm.zonesByProduct = vm.zonesByProduct[product.id];

        vm.zonesLoaded = true;
      });
    }
  }
})();
